var ArtlyProductPage = ArtlyProductPage || {};
!(function () {
  var t = ArtlyProductPage;
  function e() {
    var e = t.productId;
    if (!Artly.productData[e])
      try {
        var a = document.getElementById("ProductJson-" + e);
        a
          ? (Artly.productData[e] = JSON.parse(a.innerHTML))
          : console.error("product json not found for: " + e);
      } catch (t) {
        console.error("exception loading product json: " + t);
      }
    return (
      Artly.productData[e] ||
      (console.error("Product data missing for id: " + e), {})
    );
  }
  function a() {
    return $(".Section#section-id-" + (t.sectionId || t.productId));
  }
  function r() {
    var t = [],
      r = a();
    r.length || console.error("section not found");
    var n = e().options;
    for (var o of n)
      if ("Title" != o) {
        var i = Artly.Utils.safeHTMLString(o),
          d = $(r)
            .find("[data-optionname=" + i + "]")
            .filter(":input");
        (d && d.length) ||
          console.error(
            `could not find anInputEl for safe option ${i} originally ${o}`
          );
        var s = l(d);
        s ? t.push(s) : t.push(null);
      }
    return t;
  }
  function n() {
    var t = {},
      r = a(),
      n = e().options;
    for (var o of n) {
      var i = Artly.Utils.safeHTMLString(o),
        d = l($(r).find("input[data-optionname=" + i + "]"));
      d && (t[o] = d);
    }
    return t;
  }
  function o(t) {
    return (function (t, a) {
      var r = e().variants;
      if (!r) return null;
      if (1 == r.length) return r[0];
      var n = t.length > 0 ? t[0] : null,
        o = t.length > 1 ? t[1] : null,
        i = t.length > 2 ? t[2] : null;
      for (var l of r)
        if (a) {
          if (
            !(
              (null != n && n != l.option1) ||
              (null != o && o != l.option2) ||
              (null != i && i != l.option3)
            )
          )
            return l;
        } else if (n == l.option1 && o == l.option2 && i == l.option3) return l;
      return null;
    })(r(), t);
  }
  function i() {
    return (function (t) {
      var a = e().variants;
      if (!a || !t) return null;
      var r = t.length > 0 ? t[0] : null,
        n = t.length > 1 ? t[1] : null,
        o = t.length > 2 ? t[2] : null,
        i = [];
      for (var l of a)
        ((null != r && r == l.option1) ||
          (null != n && n == l.option2) ||
          (null != o && o == l.option3)) &&
          i.push(l);
      return i;
    })(r());
  }
  function l(t) {
    return "radio" == $(t).prop("type")
      ? $(t).filter(":checked").val()
      : "select-one" == $(t).prop("type")
      ? t[0].value
      : "text" == $(t).prop("type")
      ? $(t).val()
      : null;
  }
  function d() {
    var t,
      r = a();
    if (((t = e().variants) ? t.length : 0) <= 1) return [];
    var n = e().options,
      o = [];
    for (var i of n) {
      var d = Artly.Utils.safeHTMLString(i);
      l($(r).find("input[data-optionname=" + d + "]")) || o.push(i);
    }
    return o;
  }
  function s() {
    var t = a(),
      e = $(t).find(".ProductDetailsContainer");
    if (e.length) {
      "object" == typeof ArtlyLocalization &&
        ArtlyLocalization.localizeLinks(e),
        Artly.setupAccordionDrawer(e, "ProductDetailsContainer");
      var r = $(t).find(".ProductDescriptionDetails"),
        n = $(e).find("#productDescriptionDetails"),
        o = r.html();
      o && o.length && n.length
        ? ($(n).find(".DrawerContent").html(o), $(r).hide())
        : $(n).hide(),
        Artly.setupAnalyticsForSection(e, "ProductDetailsContainer");
    }
  }
  function c(e) {
    var r = a();
    if (e && $(r).find(".ProductDetailsContainer").length) {
      if (e.indexOf("/") >= 0)
        var n = PreArtly.loadHTML(e + "?view=embedded").then(function (e) {
          try {
            var a = document.createRange().createContextualFragment(e),
              r = $(a).find("#main .PageBody").html();
            return (t.productDetailsHTML = r), Promise.resolve(r);
          } catch (t) {
            return (
              console.error("error loading page html: " + t), Promise.reject()
            );
          }
        });
      else
        n = Artly.Utils.loadSectionHTML(e).then(function (e) {
          t.productDetailsHTML = e;
          var a = $(e);
          return Promise.resolve(a.html());
        });
      n.then(function (t) {
        u(t);
      }).catch(function (t) {});
    }
  }
  function u(t) {
    var e = (function (t) {
      if (t.indexOf("<h") < 0 && t.indexOf("<H") < 0) return t;
      var e = t,
        a = new RegExp("<H[26]>(.*?)</H[26]>", "ig");
      const r = "</div></div>";
      var n = 0,
        o = e.replace(a, function (t, e, a, o, i) {
          if ((n++, t.indexOf("2>") > 0)) var l = "H2Detail";
          else l = "H6Detail";
          var d = Artly.Utils.safeHTMLString(e);
          return `${
            n > 1 ? r : ""
          }<div class='AccordionDrawer ${l}' id='${d}' data-title="${d}" >\n            <div class='DropdownHeader' >${e}<div class="Chevron"></div></div><div class="DrawerContent">`;
        });
      return o + r;
    })(t);
    e.indexOf("AccordionDrawers") < 0 &&
      (e = "<div class='AccordionDrawers ProductDetails'>" + e + "</div>");
    var r = a(),
      n = $(r).find(".ProductDetailsContainer");
    $(n).append(e), s();
  }
  function f() {
    var a = e();
    Artly.registerEventTag("AddedToCart", a);
    var r = o();
    t.trackECAddToCartEvent(a, r);
    const n = new CustomEvent("AddedToCart", {
      detail: { selectedVariant: r, productId: t.productId, quantity: 1 },
    });
    window.dispatchEvent(n);
  }
  (t.productId = null),
    (t.sectionId = null),
    (t.useLocalCartPanel = !1),
    (t.useZoom = !1),
    (t.defaultPriceRangeText = null),
    (t.filterVariantImageOptionName = "Color"),
    (t.fromPriceText = null),
    (t.ToPriceText = null),
    (ArtlyProductPage.getProductId = function () {
      return t.productId;
    }),
    (ArtlyProductPage.getProductData = e),
    (t.updateWithNewProductId = function (a) {
      (t.productId = a), (t.sectionId = a);
      e();
      t.setupProductPage();
      const r = new CustomEvent("ProductPageUpdated", {
        detail: { productId: t.productId },
      });
      window.dispatchEvent(r);
    }),
    (t.reinitLightBoxImages = function () {
      $.fancybox &&
        $.fancybox.destroy &&
        ($.fancybox.destroy(), t.initLightBoxImages());
    }),
    (t.lightboxOptions = {
      loop: !0,
      arrows: !0,
      infobar: !0,
      smallBtn: !1,
      toolbar: !0,
      clickOutside: "close",
      clickContent: function (t, e) {
        return "image" === t.type && "zoom";
      },
      clickSlide: function (t, e) {
        return "close";
      },
      mobile: {
        idleTime: !1,
        clickContent: function (t, e) {
          return "image" === t.type && "zoom";
        },
        clickSlide: function (t, e) {
          return "close";
        },
        dblclickContent: function (t, e) {
          return "image" === t.type && "zoom";
        },
        dblclickSlide: function (t, e) {
          return "close";
        },
      },
      transitionEffect: "slide",
      transitionDuration: 500,
      buttons: ["close"],
      onInit: function () {
        t.trackProductPageEvent("showLightBox");
      },
      afterShow: function (e, a) {
        t.trackProductPageEvent(
          "showLightBoxImage",
          "" + (a.index + 1),
          a.index + 1
        );
      },
    }),
    (t.initLightBoxImages = function () {
      var e = $(a()).find("[data-fancybox=lightboximages]");
      if (e.length) {
        var r = $(e).filter(":visible");
        r.length &&
          ($(r).fancybox(t.lightboxOptions),
          $(a())
            .find(".LightboxFeaturedImageLink")
            .off("click")
            .click(function (e) {
              t.trackProductPageEvent("clickFeaturedImageLink"),
                $(r[0]).click();
            }),
          $(e).click(function (e) {
            t.trackProductPageEvent(
              "clickThumbnailImage",
              $(e.currentTarget).data("image-index")
            );
          }));
      }
    }),
    (t.loadAndSetupLightbox = function () {
      var e = Artly.getURLForAsset("jquery.fancybox.min.css"),
        a = Artly.getURLForAsset("jquery.fancybox.min.js");
      a &&
        PreArtly.loadCSS(e)
          .then(function () {
            return PreArtly.loadScript(a);
          })
          .then(function () {
            ($.fancybox.defaults = Object.assign(
              $.fancybox.defaults,
              t.lightboxOptions
            )),
              t.initLightBoxImages();
          });
    }),
    (t.setupProductPage = function (a) {
      var r;
      a && (t = Object.assign(t, a)),
        e() || console.error("product data not loaded in ArtlyProductPage"),
        t.filterVariantImageOptionName &&
          t.filterVariantImageOptionName.indexOf(",") > 0 &&
          (t.filterVariantImageOptionNames =
            t.filterVariantImageOptionName.split(",")),
        t.loadAndSetupLightbox(),
        t.updateDisplayForSoldOutOptions(),
        ArtlyProductPage.updateDisplayForSelectedVariant(),
        t.productDetailsHTML
          ? u(t.productDetailsHTML)
          : t.productDetailsPage
          ? c(t.productDetailsPage)
          : t.productDetailsSectionId
          ? c(t.productDetailsSectionId)
          : s(),
        (r = e()),
        Artly.LocalStorage.addRecentlyViewedProduct(r),
        t.setupProductPageAnalytics(),
        (t.isSetup = !0);
      const n = new CustomEvent("ProductPageSetup", {
        detail: { productId: t.productId },
      });
      window.dispatchEvent(n);
    }),
    (t.optionIsSelected = function (t) {
      var e = n();
      return e && e[t];
    }),
    (t.getSelectedOptionsDict = function () {
      return n();
    }),
    (t.getSelectedVariant = function () {
      return t.getVariantForSelectedOptions();
    }),
    (t.getVariantForSelectedOptions = function (t) {
      return o(t);
    }),
    (t.setupBelowTheFoldAnalytics = function (t, e) {
      var a =
        e || $(t).data("event-category") || $(t).attr("id") || "BelowTheFold";
      Artly.setupAnalyticsForSection(t, "ProductPage-" + a);
    }),
    (t.setupProductPageAnalytics = function () {
      var t = a();
      Artly.setupAnalyticsF,
        this.setupBelowTheFoldAnalytics(
          $(t).find(".BelowTheFoldRecommendations"),
          "BelowTheFold"
        );
    }),
    (t.trackProductPageEvent = function (t, e, a) {
      Artly.trackEvent("ProductPage", t, e, a);
    }),
    (t.trackECProductViewEvent = function (e) {
      t.trackECEvent("detail", e);
    }),
    (t.trackECAddToCartEvent = function (e, a) {
      t.trackECEvent("add", e, a);
    }),
    (t.trackECEvent = function (t, e, a) {
      e &&
        PreArtly.waitUntilTrue(function () {
          return "function" == typeof ga;
        }).then(function () {
          var r = e.id;
          if (
            ((void 0 !== window.gaplugins &&
              "function" == typeof window.gaplugins.EC) ||
              "add" != t ||
              ga("send", "event", e.title, "Added Product", r),
            ga("require", "ec"),
            ga("ec:addProduct", {
              id: "" + r,
              name: e.title + " (Product)",
              category: e.type,
              brand: e.vendor + "-Artly",
              price: e.price ? e.price / 100 : 0,
              quantity: 1,
            }),
            ga("ec:setAction", t),
            ga("send", "event", "ec", t, "" + e.id),
            ga("send", "event", "ec", t + "-Title", "" + e.title),
            a)
          ) {
            var n = e.title + "-" + a.title;
            ga("send", "event", "ec", t + "-Variant", n);
          }
        });
    }),
    (t.showMissingOptionsAlert = function (e) {
      e.length > 1
        ? Artly.showNonModalAlert(
            t.select_options,
            Artly.Utils.arrayAsDisplayString(e) + "."
          )
        : 1 == e.length &&
          Artly.showNonModalAlert(t.select_options, e[0] + "."),
        t.trackProductPageEvent(
          "showMissingOptionsAlert",
          Artly.Utils.arrayAsDisplayString(e)
        );
    }),
    (t.checkOptionsAndDisplayMessageIfMissing = function () {
      var t = d();
      return !t || !t.length || (this.showMissingOptionsAlert(t), !1);
    }),
    (t.validateBuyNow = function () {
      this.checkOptionsAndDisplayMessageIfMissing();
      var e = t.getProductData();
      Artly.registerEventTag("BuyNowButtonClicked", e),
        console.log("registered buy now button click: " + e.title);
    }),
    (t.validateAndAddToCart = function (e) {
      var r = d();
      if (r && r.length)
        return (
          (r = r.map(function (t) {
            return t.toLowerCase();
          })),
          void this.showMissingOptionsAlert(r)
        );
      t.useLocalCartPanel
        ? this.addToCartAndShowCartPanel(e)
        : (f(), a().find("form").submit());
    }),
    (t.addToCartAndShowCartPanel = function (e) {
      var r = o();
      if (r) {
        Artly.showNonModalSpinner();
        var i = a(),
          l = $(i).find("#quantity").val() || 1,
          d = $(i).find("#messageProperty"),
          s = ($(d).attr("data-propertytype"), {}),
          c = $(i).find("input[data-propertytype]");
        if (c) {
          var u = !1;
          if (
            ($(c).each(function (t, e) {
              var a,
                r,
                o = $(e).attr("data-propertytype"),
                i = $(e).val();
              if ("Engraving" == o) {
                var l = ((a = "Engraved"), (r = n()) ? r[a] : null);
                i || "Yes" != l
                  ? i &&
                    "No" == l &&
                    (Artly.showNonModalAlert(
                      `Unused ${o}`,
                      "Please select 'yes' if you'd like this piece to be engraved."
                    ),
                    (u = !0))
                  : (Artly.showNonModalAlert(
                      `Missing ${o}`,
                      "Please enter the letters you'd like engraved."
                    ),
                    (u = !0));
              }
              o && i && (s[o] = i);
            }),
            u)
          )
            return Artly.dismissNonModalSpinner(), !1;
        }
        Artly.showNonModalSpinner("Adding item to your cart..."),
          Artly.Cart.addVariantToCart(r.id, l, s, t.productId)
            .then(function (t) {
              return (
                f(),
                e
                  ? Artly.Cart.showCartPage()
                  : Artly.Cart.showCartAsPanelOrPage()
              );
            })
            .then(function () {
              Artly.dismissNonModalSpinner();
            })
            .catch(function (t) {
              Artly.dismissNonModalSpinner();
            });
      } else
        Artly.showNonModalAlert(
          "Missing Option",
          "Please select among the available options."
        );
    }),
    (t.getOptionElForVariant = function (t) {
      var e = a();
      return $(e).find(`#variantSelector option[value=${t}]`);
    }),
    (t.getTotalInventoryAvailable = function () {
      for (
        var t = a(),
          e = $(t).find("#variantSelector option[value]"),
          r = 0,
          n = 0;
        n < 5;
        n++
      ) {
        r += $(e[n]).data("inventory_quantity");
      }
      return r;
    }),
    (t.getInventoryAvailableForVariant = function (e) {
      var a = t.getOptionElForVariant(e);
      return $(a).data("inventory_quantity");
    }),
    (t.updateDisplayForSoldOutOptions = function (r) {
      var o = e().options,
        i = o.length > 0 ? o[0] : null,
        l = o.length > 1 ? o[1] : null,
        d = o.length > 2 ? o[2] : null;
      if (!r && t.optionIsSelected(i)) var s = i;
      else s = r;
      if (!s || s == i) {
        var c = (function (t) {
            var a = e().variants;
            if (!t) return a;
            var r = e().options,
              o = n(),
              i = 0 == r.indexOf(t) ? o[t] : null,
              l = 1 == r.indexOf(t) ? o[t] : null,
              d = 2 == r.indexOf(t) ? o[t] : null,
              s = [];
            for (var c of a)
              (i && i != c.option1) ||
                (l && l != c.option2) ||
                (d && d != c.option3) ||
                s.push(c);
            return s;
          })(s),
          u = n(),
          f = a();
        for (var p in u);
        for (var g of o)
          if (s != g) {
            var v = `.ProductOptions .ProductOptionContainer#product-options-${Artly.Utils.safeHTMLString(
              g
            )}:not(.AlternateModelOptions) .ProductOptionLabel`;
            $(f).find(v).addClass("SoldOut").addClass("NotPermitted");
          }
        for (var m of c)
          if (m) {
            var y = null,
              h = null;
            i &&
              i != s &&
              ((h = Artly.Utils.safeHTMLString(m.option1)),
              (aSafeOption = Artly.Utils.safeHTMLString(i)),
              (y = $(f).find(
                `.ProductOptions #product-options-${aSafeOption} .ProductOptionLabel[data-optionvalue='${h}']`
              )),
              $(y).removeClass("NotPermitted"),
              m.available && $(y).removeClass("SoldOut")),
              l &&
                l != s &&
                ((h = Artly.Utils.safeHTMLString(m.option2)),
                (aSafeOption = Artly.Utils.safeHTMLString(l)),
                (y = $(f).find(
                  `.ProductOptions #product-options-${aSafeOption} .ProductOptionLabel[data-optionvalue='${h}']`
                )),
                $(y).removeClass("NotPermitted"),
                m.available && $(y).removeClass("SoldOut")),
              d &&
                d != s &&
                ((h = Artly.Utils.safeHTMLString(m.option3)),
                (aSafeOption = Artly.Utils.safeHTMLString(d)),
                (y = $(f).find(
                  `.ProductOptions #product-options-${aSafeOption} .ProductOptionLabel[data-optionvalue='${h}']`
                )),
                $(y).removeClass("NotPermitted"),
                m.available && $(y).removeClass("SoldOut"));
          }
        var P = $(f).find(".ProductOptions .ProductOptionLabel");
        $(P).attr("aria-label", ""),
          $(P)
            .filter(".SoldOut")
            .each(function (t, e) {
              var a = $(e).attr("data-optionname"),
                r = $(e).attr("data-optionvalue");
              $(e).attr("aria-label", `${a} ${r} is sold out`);
            });
      }
    }),
    (t.updateDisplayForSelectedVariant = function () {
      var r = e(),
        n = o(),
        l = a(),
        s = $(l).find("form select#variantSelector"),
        c = $(l).find("form #addToCartButton"),
        u = $(l).find("#messageProperty");
      if (
        ($(l).removeClass("NoVariantSelected"),
        $(l).removeClass("VariantSoldOut"),
        $(l).removeClass("VariantInStock"),
        $(l).removeClass("VariantPreorder"),
        $(l).removeClass("ValidVariantSelected"),
        $(l).removeClass("VariantNotPermitted"),
        n)
      ) {
        $(l).addClass("ValidVariantSelected");
        var f = $(s).find("option[value='" + n.id + "']");
        $(f).prop("selected", "selected");
        var p = n.price,
          g = Artly.Shopify.Currency.formatMoney(p);
        $(l).find(".ProductPrice").html(g);
        $(f).data("available");
        var v = $(f).attr("data-inventory_quantity"),
          m = $(f).attr("data-inventory_management"),
          y = $(f).attr("data-inventory_policy"),
          h = parseInt($(f).attr("data-instock")),
          P = parseInt($(f).attr("data-preorder"));
        isNaN(P) && (P = 0),
          $(l).attr("data-selectedvariant-instock", h),
          $(l).attr("data-selectedvariant-onpreorder", P),
          $(l).attr("data-selectedvariant-inventory_quantity", v);
        var S = h || P,
          A = $(l).find(".InStockMessage");
        S
          ? 1 == S
            ? A.html(t.instock_message_1)
            : A.html(t.instock_message_num)
          : A.html(t.instock_message_0),
          A.find(".NumberRemaining").text(S),
          S > 0 && S <= t.showNumRemainingThreshold
            ? A.addClass("ShowNumRemaining")
            : A.removeClass("ShowNumRemaining"),
          $(l).removeAttr("data-selectedvariant-next-incoming-date");
        var C = $(l).find(".NextIncomingDate");
        $(C).text("");
        var I = $(f).data("next_incoming_date");
        try {
          if (I) {
            var O = new Date(I).toISOString(),
              b = O.slice(0, O.length - 1),
              w = new Date(b);
            $(C).attr("data-date", I),
              $(l).attr("data-selectedvariant-next-incoming-date", I);
            var x = w.toLocaleDateString("default", { month: "long" });
            if (1 == w.getDate() && t.available_1st_of_month_message)
              $(C).html(
                `${t.available_1st_of_month_message}<span class='DateString'>${x}</div>`
              );
            else if (15 == w.getDate() && t.available_15th_of_month_message)
              $(C).html(
                `${t.available_15th_of_month_message}<span class='DateString'>${x}</div>`
              );
            else if (w.getDate() >= 28 && t.available_last_day_of_month_message)
              $(C).html(
                `${t.available_last_day_of_month_message}<span class='DateString'>${x}</div>`
              );
            else {
              $(C).html(
                `${
                  t.available_date_message
                }<span class='DateString'>${w.toLocaleDateString(
                  "en-US"
                )}</div>`
              ),
                "object" == typeof Rollbar &&
                  "function" == typeof Rollbar.warning &&
                  Rollbar.warning(
                    "Non-standard incoming date: " + I + " local: " + b
                  );
            }
          }
        } catch (t) {
          console.error("error parsing date: " + t),
            "object" == typeof Rollbar &&
              "function" == typeof Rollbar.warning &&
              Rollbar.warning("error parsing incoming date: " + t);
        }
        if (n.compare_at_price && n.compare_at_price > n.price) {
          var L = Artly.Shopify.Currency.formatMoney(n.compare_at_price);
          $(l).find(".CompareAtPrice").html(L);
          var M = Artly.Shopify.Currency.formatMoney(
            n.compare_at_price - n.price
          );
          $(l).find(".MoneySavings").html(M),
            $(l).find(".PriceContainer").addClass("OnSale");
        } else $(l).find(".PriceContainer").removeClass("OnSale");
        if ((m || (y = "continue"), n.available || "continue" == y))
          if (!m || h || "continue" == y)
            $(l).addClass("VariantInStock"),
              $(c).text(t.addToCartLabel),
              t.productLineItemMessage && t.productLineItemMessage.length
                ? ($(u).attr("data-propertytype", "Important"),
                  $(u).val(t.productLineItemMessage))
                : $(C).length && !h
                ? ($(u).val($(C).text()),
                  $(u).attr("data-propertytype", "Expected Ship Date"))
                : ($(u).attr("data-propertytype", ""), $(u).val("")),
              t.trackProductPageEvent(
                "selectVariantInStock",
                r.title + " - " + n.title
              );
          else if (P) {
            $(l).addClass("VariantPreorder");
            var V = $(f).attr("data-preordermessage") || t.preorderMessage,
              T = $(f).attr("data-preordermessage") || t.preorderCartMessage,
              D =
                $(f).attr("data-preorderbuttonLabel") || t.preorderButtonLabel;
            $(c).text(D),
              I && $(C).text().length ? (T = $(C).text()) : $(C).html(V),
              $(u).attr("data-propertytype", "Preorder"),
              $(u).val(T),
              t.trackProductPageEvent(
                "selectVariantPreorder",
                r.title + " - " + n.title
              );
          } else
            $(l).addClass("VariantSoldOut"),
              t.trackProductPageEvent(
                "selectVariantSoldOut",
                r.title + " - " + n.title
              );
        else
          $(l).addClass("VariantSoldOut"),
            t.trackProductPageEvent(
              "selectVariantSoldOut",
              r.title + " - " + n.title
            );
      } else {
        $(s).find("option:selected").removeAttr("selected"),
          $(c).text(t.select_options);
        var _ = d();
        if (_ && _.length)
          $(l).addClass("NoVariantSelected"),
            t.getTotalInventoryAvailable() <= 0 &&
              !t.continueSellingIfNotInStock &&
              !t.productIsAvailable &&
              ($(l).addClass("VariantSoldOut"),
              t.trackProductPageEvent(
                "showingSoldOutProduct",
                r.title + " - " + t.productId
              ));
        else $(l).addClass("VariantNotPermitted");
        var k = i();
        if (k && k.length) {
          let e = Number.MAX_SAFE_INTEGER,
            a = 0;
          for (var E = 0; E < k.length; E++)
            k[E].price > a && (a = k[E].price),
              k[E].price < e && (e = k[E].price);
          if ((console.log(`aMinPrice  ${e} aMaxPrice  ${a}`), e < a))
            var N = `${t.fromPriceText} ${Artly.Shopify.Currency.formatMoney(
              e
            )} ${t.toPriceText} ${Artly.Shopify.Currency.formatMoney(a)}`;
          else N = Artly.Shopify.Currency.formatMoney(e);
          $(l).find(".ProductPrice").html(N);
        } else
          t.defaultPriceRangeText
            ? $(l).find(".ProductPrice").html(t.defaultPriceRangeText)
            : (console.error(
                "no variants for selected option and no default price range"
              ),
              $(l).find(".ProductPrice").html(""));
      }
      t.showImagesForVariant();
    }),
    (t.showImagesForVariant = function () {
      var e = n();
      if (e && t.filterVariantImagesByOption) {
        var r = a(),
          i = $(r).find(".GalleryItem"),
          l = $(r).find(".ProductImageGalleryContainer");
        if (
          ($(l).addClass("OptionSelected"), t.filterVariantImageOptionNames)
        ) {
          for (
            var d = [], s = 0;
            s < t.filterVariantImageOptionNames.length;
            s++
          )
            if (e[t.filterVariantImageOptionNames[s]]) {
              var c = t.filterVariantImageOptionNames[s],
                u = e[c];
              d.push(u);
              var f = Artly.Utils.safeHTMLString(u);
              $(l).attr("data-" + c, u);
            }
          i.removeClass("CurrentVariantImage"),
            i.attr("data-currentVariantImageIndex", ""),
            (j = 0),
            i.each(function (t, e) {
              var a =
                  $(e).attr("data-alt") + " " + $(e).attr("data-src-handle"),
                r = d.filter(function (t) {
                  return a.indexOf(t) >= 0;
                });
              r.length == d.length &&
                (j++,
                $(e).addClass("CurrentVariantImage"),
                $(e).attr("data-currentVariantImageIndex", j));
            });
        } else if (
          ((u = e[t.filterVariantImageOptionName]),
          (c = Artly.Utils.safeHTMLString(t.filterVariantImageOptionName)),
          u)
        ) {
          $(l).addClass("OptionSelected"),
            $(l).addClass(c + "OptionSelected"),
            $(l).attr("data-" + c, u);
          f = Artly.Utils.safeHTMLString(u);
          if (
            (i.removeClass("CurrentVariantImage"),
            t.filterAlternateImagesByAltText)
          ) {
            let t = `.ProductImageGalleryContainer .GalleryItem[data-alt*="${f}" i]`;
            $(t).addClass("CurrentVariantImage"),
              (t = `.ProductImageGalleryContainer .GalleryItem[data-src-handle*="${f}" i]`),
              $(t).addClass("CurrentVariantImage");
          }
        } else
          i.addClass("CurrentVariantImage"),
            $(l).removeClass("OptionSelected"),
            $(l).removeClass(c + "OptionSelected"),
            $(l).attr("data-" + c, "");
        var p = o(!0);
        if (p && p.featured_image) {
          var g = p.featured_image.src.split("/"),
            v = Artly.Utils.safeHTMLString(g[g.length - 1].split("?")[0]),
            m = i.filter("[data-src-handle*='" + v + "']");
          m.length && $(l).prepend(m);
        }
        var y = $(l).find(".CurrentVariantImage .GalleryImage");
        (y && y.length) ||
          (console.error(
            `no variant's images match selected option value: ${u}`
          ),
          i.addClass("CurrentVariantImage"),
          (y = i.filter(".CurrentVariantImage").find(".GalleryImage")));
        var h = $(r).find(".ProductHeroImageContainer .ProductImage"),
          P = y.attr("data-srcset");
        P ? h.attr("src", null) : h.attr("src", y.attr("src")),
          h.attr("srcset", P),
          h.attr("data-srcset", P),
          r
            .find(".ProductHeroImageContainer")
            .attr("data-zoom-image", y.attr("data-zoom-image")),
          r
            .find(".ProductHeroImageContainer .LightboxFeaturedImageLink")
            .attr("data-src", y.attr("data-zoom-image"));
      }
    }),
    (t.handleOptionSelected = function (e) {
      var r = e.getAttribute("data-optionname"),
        n = (e.getAttribute("id"), e.getAttribute("type")),
        o = a();
      if ("select" == n) var i = $(e).children("option:selected").val();
      else i = e.value;
      var l = ".SelectedOptionInputElement[data-optionname='" + r + "']",
        d = $(o).find(l);
      return (
        $(d).val(i),
        $(d).attr("value", i),
        $(d).attr("data-selected-option-value", i),
        $(o)
          .find(".SelectedOptionLabel[data-optionname=" + r + "]")
          .text(i),
        t.reinitLightBoxImages(),
        t.updateDisplayForSelectedVariant(),
        t.updateDisplayForSoldOutOptions(r),
        t.updateUserPreferences(),
        t.updateProductURL(),
        Promise.resolve()
      );
    }),
    (t.updateUserPreferences = function () {
      try {
        var t = n();
        for (var e in t) window.localStorage.setItem("ArtlyParam-" + e, t[e]);
      } catch (t) {}
    }),
    (t.updateProductURL = function (t, e) {
      var a = o();
      if (a || t) {
        if (t) var r = t;
        else r = location.pathname;
        var n = new URLSearchParams(location.search);
        a ? n.set("variant", a.id) : n.delete("variant");
        var i = `${r}`,
          l = n.toString();
        if (
          (l && (i.indexOf("?") < 0 ? (i += "?") : (i += "&"), (i += l)), e)
        ) {
          var d = { location: i };
          history.pushState(d, "", i);
        } else window.history.replaceState({}, "", i);
      }
    });
})();
